import React from "react";

import { observer, inject } from "mobx-react";
import { toJS } from "mobx";

import Icon from "sulu-admin-bundle/components/Icon";
import Table from "sulu-admin-bundle/components/Table";
import SingleSelect from "sulu-admin-bundle/components/SingleSelect";

const Option = SingleSelect.Option;
const { Row, Cell } = Table;

const StaffRow = inject("selectionStore")(
    observer(({ selectionStore, player, index, disabled }) => {
        const teamRoleList = toJS(
            selectionStore.resourceStore?.data?.teamRoleList,
        );
        return (
            <>
                <Row>
                    <Cell>{index + 1}</Cell>
                    <Cell>{player.contactName}</Cell>
                    <Cell>
                        <div
                            style={{
                                width: "12rem",
                            }}
                        >
                            <SingleSelect
                                disabled={disabled}
                                name={"role"}
                                value={Number(player.matchRole)}
                                onChange={(value) => {
                                    selectionStore.setRole(
                                        player.contact,
                                        value,
                                    );
                                }}
                            >
                                {Object.entries(teamRoleList).map(
                                    ([id, label]) => {
                                        return (
                                            <Option key={id} value={Number(id)}>
                                                {label}
                                            </Option>
                                        );
                                    },
                                )}
                            </SingleSelect>
                        </div>
                    </Cell>
                    <Cell>
                        {disabled ? null : (
                            <div
                                onClick={() => {
                                    selectionStore.removeStaff(player.contact);
                                }}
                            >
                                <Icon name="su-trash-alt" />
                            </div>
                        )}
                    </Cell>
                </Row>
            </>
        );
    }),
);

export default StaffRow;
